<router-outlet></router-outlet>
<div class="fb-customerchat"
     page_id="genalizer">
</div>
